module.exports = __webpack_public_path__ + "img/119.24d8672f.jpg";